import { ChangeEvent, FC } from 'react';
import { PrefectureDrillDown } from './PrefectureDrillDown';
import { WardDrillDown } from './WardDrillDown';
import {
  CityDrillDownType,
  PrefectureDrillDownType,
  WardDrillDownType,
} from './types';
import { CityDrillDown } from './CityDrillDown';

export type LocationDrillDownType =
  | PrefectureDrillDownType
  | CityDrillDownType
  | WardDrillDownType;

/**
 * Propsの型定義
 * @param drillDown
 * @param onChange チェックボックス更新処理
 */
interface Props {
  drillDown: LocationDrillDownType;
  onChange: (event: ChangeEvent<HTMLInputElement>, selectedId: string) => void;
}

export const LocationDrillDown: FC<Props> = ({ drillDown, onChange }) => {
  const { type } = drillDown;
  switch (type) {
    case 'prefecture': {
      return <PrefectureDrillDown drillDown={drillDown} onChange={onChange} />;
    }
    case 'city': {
      return <CityDrillDown drillDown={drillDown} onChange={onChange} />;
    }
    case 'ward': {
      return <WardDrillDown drillDown={drillDown} onChange={onChange} />;
    }
    default:
      return null;
  }
};
